import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../client/client';
import NewspaperSection from './NewspaperSection';
import Accordion from './Accordion';
import { EsqueletoArticulo } from './Esqueleto';
import { fechaRelativa } from '../utils/fecha';

// SliderNotasCat solo muestra imagen y titulo: no hace falta el "body".
const LIGHT_FIELDS = 'id, number, title, written_by, category_id, image_url, created_at, updated_at, fecha_publicacion';

const Categorias = () => {
  const text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...";
  const { id } = useParams();
  const [categoryData, setCategoryData] = useState(null);
  const [latestNews, setLatestNews] = useState(null);
  const [filteredNews, setFilteredNews] = useState([]);
  // Rejilla paginada: el carrusel sirve para ojear, pero con archivo histórico
  // hace falta poder recorrer la sección entera.
  const POR_TANDA = 1;
  const [visibles, setVisibles] = useState(POR_TANDA);

  // Al pasar de una sección a otra React reutiliza este mismo componente (la
  // ruta es la misma, solo cambia :id), así que su estado sobrevive. Antes, si
  // la sección nueva no tenía una nota principal o tardaba en responder, se
  // seguía viendo la anterior: la pantalla parecía "atascada". Ahora se vacía
  // todo al cambiar de sección, y las respuestas viejas se descartan.
  useEffect(() => {
    let cancelado = false;

    setCategoryData(null);
    setLatestNews(null);
    setFilteredNews([]);
    setVisibles(POR_TANDA);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const cargar = async () => {
      const [categoria, principal, todas] = await Promise.all([
        supabase.from('categorias').select('*').eq('id', id),
        supabase
          .from('news')
          .select('*')
          .eq('category_id', id)
          .eq('number', 1)
          .order('created_at', { ascending: false })
          .limit(1),
        supabase
          .from('news')
          .select(LIGHT_FIELDS)
          .eq('category_id', id)
          .order('created_at', { ascending: false }),
      ]);

      if (cancelado) return;

      if (categoria.error) console.error('Error fetching category data:', categoria.error);
      else setCategoryData(categoria.data?.[0] || null);

      if (principal.error) console.error('Error fetching latest news:', principal.error);
      else setLatestNews(principal.data?.[0] || null);

      if (todas.error) console.error('Error fetching all news:', todas.error);
      else setFilteredNews(todas.data || []);
    };

    cargar();

    return () => {
      cancelado = true;
    };
  }, [id]);

  // La destacada ya se muestra arriba: no debe repetirse en la rejilla.
  const restantes = filteredNews.filter((n) => !latestNews || n.id !== latestNews.id);

  // En la sección Legal las fotos son ilustraciones casi cuadradas que el
  // recorte de la tarjeta cortaba: se muestran completas sobre un fondo
  // difuminado de la propia foto.
  const fotoCompleta = /legal/i.test(categoryData?.name || '');

  // Título del bloque inferior según la sección. Se busca por el nombre que
  // tenga la categoría en la base de datos, sin distinguir mayúsculas.
  const TITULOS_OTROS = [
    [/art[ií]culo/i, 'Otros artículos'],
    [/entrevista/i, 'Otras entrevistas'],
    [/legal/i, 'Otras noticias'],
    [/historia/i, 'Otras historias'],
    [/perfil/i, 'Otros perfiles'],
    [/semblanza/i, 'Otras semblanzas'],
  ];
  const nombreSeccion = categoryData?.name || '';
  const tituloOtros =
    (TITULOS_OTROS.find(([patron]) => patron.test(nombreSeccion)) || [])[1] ||
    'Otras noticias';

  if (!categoryData) {
    return (
      <div className="ed-shell">
        <EsqueletoArticulo />
      </div>
    );
  }

  return (
    <div>
      <div className="class justify-center">
        <h1 className='title uppercase' style={{ color: categoryData.color }}>{categoryData.name}</h1>

        {id === '6' && <Accordion />}

        {latestNews ? (
          <NewspaperSection
            id={latestNews.id}
            title={latestNews.title}
            image={latestNews.image_url || "https://via.placeholder.com/300"}
            text={latestNews.body || text}
            color={categoryData.color}
            subtitle={latestNews.written_by}
          />
        ) : (
          <p className="categoria-sin-noticias">No hay noticias recientes en esta categoría.</p>
        )}
        {id !== '7' && (
        <div className="mt-100">
          <h1>{tituloOtros}</h1>

          {restantes.length === 0 ? (
            <p className="busqueda-status">
              Por ahora no hay más notas en esta sección.
            </p>
          ) : (
            <>
              <div className="ed-rejilla">
                {restantes.slice(0, visibles).map((nota) => (
                  <Link key={nota.id} to={`/noticias/${nota.id}`} className="ed-tarjeta">
                    <div
                    className={`ed-tarjeta__foto ${
                      nota.title?.toLowerCase().includes('central 105')
                        ? 'imagen-central105'
                        : ''
                    } ${fotoCompleta ? 'ed-tarjeta__foto--completa' : ''}`}
                    style={fotoCompleta ? { '--foto': `url("${nota.image_url}")` } : undefined}>
                    <img
                      src={nota.image_url}
                      alt={nota.title}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                    <h2 className="slider-text_notas ed-tarjeta__titulo">{nota.title}</h2>
                    <p className="ed-tarjeta__fecha">
                      {fechaRelativa(nota.fecha_publicacion || nota.updated_at || nota.created_at)}
                    </p>
                  </Link>
                ))}
              </div>

              {visibles < restantes.length && (
                <div className="ed-cargar-mas">
                  <button
                    type="button"
                    className="button_revista"
                    onClick={() => setVisibles((v) => v + POR_TANDA)}
                  >
                    Cargar más ({restantes.length - visibles})
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        )}
      </div>
    </div>
  );
};

export default Categorias;
